import { DrawerState } from 'ia-react-core/~/interfaces/DrawerState';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import openDrawerById from '../../../actions/drawer-fn/openDrawerById';
import closeDrawerById from '../../../actions/drawer-fn/closeDrawerById';
import closeAllDrawers from '../../../actions/drawer-fn/closeAllDrawers';
import openDrawerByName from '../../../actions/drawer-fn/openDrawerByName';
import closeDrawerByName from '../../../actions/drawer-fn/closeDrawerByName';

export default function drawerReducer(state: DrawerState, action: CoreAction) {
  const drawerId = state?.drawerId;
  const name = state?.name;

  switch (action.type) {
    case `${openDrawerById.type}/${drawerId}`:
    case `${openDrawerByName.type}/${name}`:
      return reduceOpenDrawer(state);
    case `${closeDrawerById.type}/${drawerId}`:
    case `${closeDrawerByName.type}/${name}`:
    case closeAllDrawers.type:
      return reduceCloseDrawer(state);
    default:
      return state;
  }
}

function reduceOpenDrawer(state: DrawerState) {
  return {
    ...state,
    isOpened: true,
  };
}

function reduceCloseDrawer(state: DrawerState) {
  return {
    ...state,
    isOpened: false,
  };
}
